<dialog
  #dialog
  class="document-viewer"
  [attr.aria-label]="key('viewerTitle') | translate"
  (cancel)="dialogCancel.emit($event)"
>
  <div class="document-viewer-bar">
    <div class="document-viewer-bar-main">
      <h3>
        {{
          session.title
            ? (typeKey(session.title) | translate)
            : (key('viewerTitle') | translate)
        }}
      </h3>
      @if (session.fileName) {
        <p>{{ session.fileName }}</p>
      }
    </div>
    <div class="document-viewer-bar-actions">
      <button
        type="button"
        class="document-viewer-action"
        [title]="key('download') | translate"
        [attr.aria-label]="key('download') | translate"
        [disabled]="
          session.loading || !!session.errorMessage || !session.safeUrl
        "
        (click)="download.emit()"
      >
        <fa-icon icon="download"></fa-icon>
      </button>
      <button
        type="button"
        class="document-viewer-action"
        [title]="'nav.close' | translate"
        [attr.aria-label]="'nav.close' | translate"
        (click)="closeRequest.emit()"
      >
        <fa-icon icon="xmark"></fa-icon>
      </button>
    </div>
  </div>
  <div class="document-viewer-body">
    @if (session.loading) {
      <p class="document-viewer-status">{{ 'common.loading' | translate }}</p>
    }
    @if (session.errorMessage) {
      <p class="document-viewer-status document-viewer-status--error">
        {{ session.errorMessage }}
      </p>
    }
    @if (!session.loading && !session.errorMessage && session.safeUrl) {
      @if (session.kind === 'image') {
        <img
          class="document-viewer-image"
          [src]="session.safeUrl"
          [alt]="session.fileName"
        />
      } @else if (session.kind === 'pdf' && session.pdfInline) {
        <iframe
          class="document-viewer-frame"
          [src]="session.safeUrl"
          [attr.title]="session.fileName"
        ></iframe>
      } @else if (session.kind === 'pdf') {
        <div class="document-viewer-fallback">
          <p class="document-viewer-status document-viewer-status--error">
            {{
              session.errorMessage || (key('viewPdfMobile') | translate)
            }}
          </p>
          <button
            type="button"
            class="document-viewer-btn"
            (click)="openExternally.emit()"
          >
            {{ key('openExternally') | translate }}
          </button>
        </div>
      } @else {
        <div class="document-viewer-fallback">
          <p class="document-viewer-status">
            {{ key('viewUnsupported') | translate }}
          </p>
          <button
            type="button"
            class="document-viewer-btn"
            (click)="download.emit()"
          >
            {{ key('download') | translate }}
          </button>
        </div>
      }
    }
  </div>
</dialog>
